import {
    COMPARE_MONTHS_SALES_ALL_SUCCESS,
    COMPARE_MONTHS_ALL_LOADING
  } from '../actions/compareMonthsAllAction';
  
  const initialState = {
    amazon: {
      compareMonthSalesAllData: null,
      isAllLoading: true
    },
    shopify: {
        compareMonthSalesAllData: null,
        isAllLoading: true
    },
    wholesale: {
        compareMonthSalesAllData: null,
        isAllLoading: true
    }
  };
  
  const compareMonthAllReducer = (state = initialState, action = {}) => {
    switch (action.type) {
      case COMPARE_MONTHS_SALES_ALL_SUCCESS:
        return {
          ...state, [action?.vendor]: { compareMonthSalesAllData: action.data, isAllLoading: false }
        };
      case COMPARE_MONTHS_ALL_LOADING:
        return { ...state, [action.vendor]: { ...state?.[action.vendor], isAllLoading: action.isAllLoading } };
  
      default:
        return state;
    }
  };
  
  export default compareMonthAllReducer;
  